import goblinSprite from '@assets/images/goblin-sprite.png';
import { GameConfiguratorSingleton } from '@services/GameConfiguratorSingleton';
import { CELL_GAP, CELL_SIZE } from '@static/game';
import { COLORS, FONT_FAMILY, SIZES } from '@static/styles';
import { createFontStyle } from '@utils/createFontStyle';
var GoblinEnemy = /** @class */ (function () {
    function GoblinEnemy(y) {
        this._health = 100;
        this._reward = 50;
        this._speed = 0.4;
        this._damage = 0.2;
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        this._context = this._gameConfigurator.context;
        this._enemySprite = new Image();
        this._enemySprite.src = goblinSprite;
        this._x = this._gameConfigurator.canvasWidth;
        this._y = y;
        this._width = CELL_SIZE - CELL_GAP * 2;
        this._height = CELL_SIZE - CELL_GAP * 2;
        this._movement = this._speed;
        this._frameX = 0;
        this._frameY = 0;
        this._minFrame = 0;
        this._maxFrame = 3; // Sprite consists of 4 pictures
    }
    GoblinEnemy.prototype.move = function () {
        this._x -= this._movement;
        this._frameX += 0;
        // Slow down animation 10 times
        if (this._gameConfigurator.frame % 10 !== 0)
            return;
        if (this._frameX < this._maxFrame) {
            this._frameX++;
        }
        else {
            this._frameX = 0;
        }
    };
    GoblinEnemy.prototype.draw = function () {
        var imageWidth = 61;
        var imageHeight = 54;
        this._frameY = this._movement ? 0 : 1; // first line in sprite - move, second - attack
        this._context.drawImage(this._enemySprite, this._frameX * imageWidth, this._frameY * imageHeight, imageWidth, imageHeight, this._x, this._y, this._width, this._height);
        this._context.fillStyle = COLORS.textColor;
        this._context.font = createFontStyle(SIZES.characterHealthSize, FONT_FAMILY);
        this._context.textAlign = 'start';
        this._context.textBaseline = 'middle';
        this._gameConfigurator.context.fillText(Math.floor(this._health).toString(), this._x + CELL_SIZE / 2, this.y - CELL_GAP);
    };
    Object.defineProperty(GoblinEnemy.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "x", {
        get: function () {
            return this._x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "y", {
        get: function () {
            return this._y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "speed", {
        get: function () {
            return this._speed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "reward", {
        get: function () {
            return this._reward;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "damage", {
        get: function () {
            return this._damage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "health", {
        get: function () {
            return this._health;
        },
        set: function (health) {
            this._health = health;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoblinEnemy.prototype, "movement", {
        set: function (movement) {
            this._movement = movement;
        },
        enumerable: false,
        configurable: true
    });
    return GoblinEnemy;
}());
export { GoblinEnemy };
